import { Aspect } from '@teambit/harmony';

export const CommandBarAspect = Aspect.create({
  id: 'teambit.explorer/command-bar',
  dependencies: [],
  defaultConfig: {},
});

export default CommandBarAspect;
